import React from "react";
import Headers from "../components/Header";
import Footer from "../Screen/Footer";
import Contact from "../Images/contactus.png";
import { FaMapMarkerAlt, FaEnvelope, FaPhone } from "react-icons/fa";

const Contactus = () => {
  const contactDetails = [
    {
      icon: <FaMapMarkerAlt />,
      title: "Address",
      details: ["Eucto - 36 Muscot Drive", "Stoney Creek, Ontario,L8J 1X2", "Canada"],
    },
    {
      icon: <FaEnvelope />,
      title: "Email",
      details: ["support@blaccdot.ca", "sale@blaccdot.com"],
    },
    {
      icon: <FaPhone />,
      title: "Phone",
      details: ["+1 (365) 336-1110"],
    },
  ];

  return (
    <>
      <Headers />
      <div className="banner">
        <div className="text-container">
          <a href="#">CONTACT US</a>
          <h1>Reach out to us</h1>
        </div>
        <div className="image-container">
          <img src={Contact} alt="Contact" />
        </div>
      </div>

      <div className="contact-container">
        {contactDetails.map((item, index) => (
          <div className="contact-card" key={index}>
            <div className="icon">{item.icon}</div>
            <h3>{item.title}</h3>
            {item.details.map((line, i) => (
              <p className="ptag" key={i}>
                {line}
              </p>
            ))}
          </div>
        ))}
      </div>

      <Footer />
    </>
  );
};

export default Contactus;
